module.exports = __webpack_public_path__ + "static/media/Quicksand_Book_Oblique.04198105.otf";